import { createSlice } from "@reduxjs/toolkit";
import { ProductData } from "@/utils/types/aem";
// import { getProductDetailsData } from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  productDetail: {} as ProductData,
};

const GetProductDetailsDataSlice = createSlice({
  name: "productDetails",
  initialState,
  reducers: {
    setProductDetailData: (state, action) => {
      state.productDetail = action?.payload?.data?.productDetailPageList || {};

    }
  },
  extraReducers: (builder) => {
    // builder.addCase(getProductDetailsData?.pending, (state) => {
    //   state.isLoading = true;
    //   state.isError = false;
    // });
    // builder.addCase(getProductDetailsData?.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.isError = false;
    //   state.productDetail = action?.payload?.["data"]?.["productDetailPageList"]  || {};
    // });
    // builder.addCase(getProductDetailsData?.rejected, (state) => {
    //   state.isLoading = false;
    //   state.isError = true;
    // });
  },
});

export const {
  setProductDetailData
} = GetProductDetailsDataSlice.actions;


export const getProductDetailsDataSlice = GetProductDetailsDataSlice.reducer;
